/**
 * OnboardingConsent — page shell that mounts ConsentGate at /onboarding/consent.
 * On completion it redirects to the intended destination (or /welcome).
 *
 * Users land here:
 *   - After signup (AuthPage redirects any logged-in user without compliance)
 *   - When a legal document version bumps (PrivacySettings surfaces the link)
 */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import ConsentGate from "@/components/ConsentGate";

export default function OnboardingConsent() {
    const nav = useNavigate();
    const location = useLocation();
    const [checking, setChecking] = useState(true);

    // If the user somehow reaches here already compliant, don't block them.
    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/consent/me");
                if (data?.compliant) {
                    const next = location.state?.next || "/welcome";
                    nav(next, { replace: true });
                    return;
                }
            } catch (_e) {
                // fall through to gate
            }
            setChecking(false);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (checking) return null;

    return (
        <ConsentGate
            onComplete={() => {
                const next = location.state?.next || "/welcome";
                nav(next, { replace: true });
            }}
        />
    );
}
